import React from 'react'
import { Box } from 'landing/kit'

const Page = (props) => (
  <Box
    pb={60}
    mx="auto"
    {...props}
  />
)

export default Page
